import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
import type { ShippingRates, ShippingRatesBody } from '../types/shipping.types';

/** Quoted live by the shipping API (up to about 10 s); never cached by the server. */
export const fetchShippingRates = async (body: ShippingRatesBody): Promise<ShippingRates> => {
  return await request.post(`${URLS.BACK_DSH}${APIS.shippingRates}`, body);
};
